<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="estadistiques">
    <ItemCommonDescription :data-card="dataCard.data[0]" @reload-data-card="reloadDataCard" />
    <!-- {{ pivotConfig && pivotConfig.dimensions.map((d)=>d.id+' '+d.role) }} -->
    <FileContentTabs
      v-model="pivotConfig"
      :unit="dataCard.data[0].measureUnit + (dataCard.data[0].symbolUnit ? ' (' + dataCard.data[0].symbolUnit + ')' : '')"
      :data-card="dataCard"
      :have-map-rep="haveMapRepresentation"
      :mobile-chart-type-open="mobileChartTypeOpen"
      :file-selected-tab="tabSelectedType"
      @toggle-mobile-type-edit="toggleMobileTypeEdit"
      @change-selected-type="changeSelectedType"
    >
      <template v-slot:table-details>
        <StatisticsTable
          v-if="contentData"
          v-model="pivotConfig"
          :data-card="dataCard"
          :current-search-count="currentSearchCount"
          :content-data="contentData"
          :total-search-count="totalSearchCount"
          @change-search-count="(val, total) => {
            currentSearchCount=val
            totalSearchCount=total
          }"
        />
      </template>
      <template v-slot:chart-details>
        <StatisticsChart
          v-if="contentData"
          v-model="pivotConfig"
          :data-card="dataCard"
          :content-data="contentData"
          :mobile-chart-type-open="mobileChartTypeOpen"
          @reload-data-card="reloadDataCard"
        />
      </template>
      <template v-slot:map-details>
        <StatisticsMap
          v-if="contentData"
          v-model="pivotConfig"
          :data-card="dataCard"
          :content-data="contentData"
          :mobile-chart-type-open="mobileChartTypeOpen"
          @reload-data-card="reloadDataCard"
        />
      </template>
    </FileContentTabs>
    <ItemViews :note-text="dataCard.data[0].notes" :views="dataCard.data[0].popularity" />
    <ItemsRelated :card-id="dataCard.data[0].id" />
  </div>
</template>

<script>
import { getStatisticsTable } from '@/services/table-api'
import ItemViews from './ItemViews'
import ItemsRelated from './ItemsRelated'
import StatisticsChart from '../charts/StatisticsChart.vue'
import StatisticsTable from '../table/StatisticsTable.vue'
import StatisticsMap from '../maps/StatisticsMap.vue'
import ItemCommonDescription from './ItemCommonDescription.vue'
import FileContentTabs from './FileContentTabs.vue'
import { hasMapRepresentation } from '../../utils/chart/mapUtils'
// import { createDefaultPivotConfig } from '@/utils/dimensionUtils.js'
/**
 * Taula estadística view disposition
 * @example [none]
 */
export default {
  name: 'StatisticsTableItem',
  components: {
    ItemViews,
    ItemsRelated,
    StatisticsChart,
    StatisticsTable,
    ItemCommonDescription,
    FileContentTabs,
    StatisticsMap,
  },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
  },
  data() {
    return {
      pivotConfig: null,
      defaultPivotConfig: null,
      currentSearchCount: null,
      totalSearchCount: null,
      mobileChartTypeOpen: false,
      currentChart: null,
      // tabSelectedType: 'table',
    }
  },
  asyncComputed: {
    contentData() {
      if (this.dataCard.values) {
        return getStatisticsTable(this.dataCard)
      } else return null
    },
  },
  computed: {
    haveMapRepresentation() {
      return hasMapRepresentation(this.dataCard)
    },
    tabSelectedType: {
      get() {
        return this.$route.query.view || 'table'
      },
      set(v) {
        let q = { ...this.$route.query, view: v }
        delete q.chart
        delete q.diff
        delete q.ccfg
        this.$router.push({ query: q })
      },
    },
    // tabSelectedType() {
    //   if (this.tabSelectedType !== 'chart' && this.tabSelectedType !== 'map')
    //     this.defaultPivotConfig = createDefaultPivotConfig(this.contentData.dimensions, null)
    // },
  },
  watch: {
    // contentData() {
    //   if (!this.defaultPivotConfig) {
    //     this.setDefaultConfigs()
    //   }
    // },
    // currentChart: {
    //   handler() {
    //     this.defaultPivotConfig = null
    //     this.setDefaultConfigs()
    //   },
    // },
    // tabSelectedType() {
    //   if (this.tabSelectedType !== 'chart')
    //     this.defaultPivotConfig = createDefaultPivotConfig(this.contentData.dimensions, null)
    // },
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
    toggleMobileTypeEdit(value) {
      this.mobileChartTypeOpen = value !== undefined ? value : !this.mobileChartTypeOpen
    },
    changeCurrentChart(value) {
      this.currentChart = value
    },
    // setDefaultConfigs() {
    //   const urlParams = new URLSearchParams(window.location.search)
    //   let viewTab = urlParams.get('view')

    //   this.defaultPivotConfig = createDefaultPivotConfig(
    //     this.contentData.dimensions,
    //     this.currentChart ? this.currentChart : viewTab === 'map' ? { id: 'map' } : null
    //   )
    // },
    changeSelectedType(value) {
      this.tabSelectedType = value
      // if (value === 'map') this.changeCurrentChart({ id: 'map' })
    },
  },
}
</script>

<style lang="stylus" scoped></style>
